import { useCallback } from "react";
import { supabase } from "@/shared/integrations/supabase/client";
import { useAuth } from "@/shared/hooks/useAuth";

interface LogActivityParams {
  module: string;
  action: string;
  details?: string;
}

export const useActivityLogger = () => {
  const { user, session } = useAuth();

  const logActivity = useCallback(
    async ({ module, action, details }: LogActivityParams) => {
      if (!user) return;
      try {
        if (!session?.user?.id || session.user.id !== user.id) return;

        const nome = (globalThis as any).__ferruginiProfileCache?.nome as string | undefined;

        await supabase.from("activity_logs").insert({
          user_id: user.id,
          user_name: nome || user.email || "",
          module,
          action,
          details: details || null,
        });
      } catch (err) {
        console.error("[ActivityLogger] Failed to log:", err);
      }
    },
    [user, session]
  );

  return { logActivity };
};
